import React, { useEffect, createContext, useState } from 'react';
import { dbAgency, dbFamMember, dbCaregivers, dbTasks, dbSeniors, dbFamtoFam, dbPending, dbClicks, dbEmails, dbArticles } from './firebase';
import Cookies from 'js-cookie';

const AppState = createContext(null);
const { Provider } = AppState;

const StateProvider = ({ children }) => {
  const [task, setTask] = useState('None');
  const [time, setTime] = useState('None');
  const [admin, setAdmin] = useState('');
  const [duration, setDuration] = useState('');
  const [taskDescription, setTaskdescription] = useState('');
  const [importance, setImportance] = useState('Medium');
  const [frequency, setFrequency] = useState('Daily');
  const [messageBody, setMessageBody] = useState('');
  const [familyMembers, setFamilyMembers] = useState('');
  const [seniors, setSeniors] = useState('');
  const [clicks, setClicks] = useState('');
  const [tasks, setTasks] = useState('');
  const [famtofam, setFamtofam] = useState('');
  const [caregivers, setCaregivers] = useState('')
  const [agencies, setAgencies] = useState('')
  const [emails, setEmails] = useState('')
  const [user, setUser] = useState(null);
  const [firsttimeuser, setFirsttimeuser] = useState(null)
  const [globaltsk, setGlobaltsk] = useState([]);
  const [name, setName] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [senior, setSenior] = useState('');
  const [correct, setCorrect] = useState(false);
  const [logged, setLogged] = useState(false);
  const [pending, setPending] = useState("");
  const [filter, setFilter] = useState("All Tasks");
  const [blogLogged, setBlogLogged] = useState(true);
  const [blogpop, setBlogpop] = useState(false);
  const [articles, setArticles] = useState('');
  const [filtercaregiver, setFilterCaregiver] = useState(true);
  const [filtermine, setFilterMine] = useState(true);
  const [filter2nd, setFilter2nd] = useState(true);
  const [filterunassigned, setFilterunassigned] = useState(true);
  const [filterAll, setFilterAll] = useState(false);
  const [deletetoggle, setDeleteToggle] = useState(false);
  const [globallogged, setGlobalLogged] = useState(false);
  const [firstlogin, setFirstLogin] = useState(false);
  const [adminRedirect,  setAdminRedirect]=useState(false);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const [artid, setArtid] = useState('');
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) {
        setFamilyMembers(snap.val());
      }
    }
    dbFamMember.on('value', handleData, error => alert(error));
    return () => { dbFamMember.off('value', handleData); };
  }, []);
  useEffect(()=>{
    console.log(Cookies.get("logged"))
  },[])
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) {
        setClicks(snap.val());
      }
    }
    dbClicks.on('value', handleData, error => alert(error));
    return () => { dbClicks.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) {
        setEmails(snap.val());
      }
    }
    dbEmails.on('value', handleData, error => alert(error));
    return () => { dbEmails.off('value', handleData); };
  }, []);

  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setCaregivers(snap.val());
    }
    dbCaregivers.on('value', handleData, error => alert(error));
    return () => { dbCaregivers.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setTasks(snap.val());
    }
    dbTasks.on('value', handleData, error => alert(error));
    return () => { dbTasks.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setFamtofam(snap.val());

    }
    dbFamtoFam.on('value', handleData, error => alert(error));
    return () => { dbFamtoFam.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setArticles(snap.val());

    }
    dbArticles.on('value', handleData, error => alert(error));
    return () => { dbArticles.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setSeniors(snap.val());
    }
    dbSeniors.on('value', handleData, error => alert(error));
    return () => { dbSeniors.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setPending(snap.val());
    }
    dbPending.on('value', handleData, error => alert(error));
    return () => { dbPending.off('value', handleData); };
  }, []);
  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) setAgencies(snap.val());
    }
    dbAgency.on('value', handleData, error => alert(error));
    return () => { dbAgency.off('value', handleData); };
  }, []);

  const numberTasks = (family) => {
    let total = 0;
    let incomplete = 0;

    // This is for Database reference Tasks
    Object.values(family["tasks"]).map(task => {
      if (tasks[task]) {
        total += 1;
        if (!tasks[task]["status"]) {
          incomplete += 1;
        }
      }
    })

    // This is for Database reference of FamtoFam
    Object.values(family["taskstofam"]).map(task => {
      if (famtofam[task]) {
        total += 1;
        if (!famtofam[task]["status"]) {
          incomplete += 1;
        }
      }
    })

    // This is for Database reference of Unassigned
    if (family["unassignedTasks"] != "null") {
      Object.values(family["unassignedTasks"]).map(task => {
        if (pending[task]) {
          total += 1;
          if (!pending[task]["status"]) {
            incomplete += 1;
          }

        }
      })
    }

    // This is for Database reference for Caregiver ToDolist
    if (family["careBool"]) {
      Object.values(family["caregivers"]).map(caregiver => {
        Object.entries(caregivers[caregiver]["todolist"]).map(task => {
          if (task[1]["type"]) {
            total += 1;
            if(!task[1]["status"]){
              incomplete+=1;
            }
          }
        })
      })
    }

    // This is for Database reference for Secondary Fam
    if (family["secondaryFam"] != "hi") {
      Object.values(family["secondaryFam"]).map(member => {
        if ( familyMembers[member] && familyMembers[member]["taskstofam"]) {
          Object.values(familyMembers[member]["taskstofam"]).map(task => {
            if (famtofam[task]) {
              total += 1;
              if (!famtofam[task]["status"]) {
                incomplete += 1;
              }
            }
          })
        }
      })
    }
    return [total, incomplete];
  }
 
  const api = {
    numberTasks,
    agencies,
    setAgencies,
    admin,
    setAdmin,
    artid,
    setArtid,
    articles,
    setArticles,
    blogpop,
    setBlogpop,
    firstlogin,
    setFirstLogin,
    globallogged,
    setGlobalLogged,
    deletetoggle,
    setDeleteToggle,
    months,
    pending,
    setPending,
    name,
    setName,
    phonenumber,
    setPhonenumber,
    senior,
    setSenior,
    firsttimeuser,
    setFirsttimeuser,
    user,
    setUser,
    task,
    setTask,
    time,
    setTime,
    duration,
    setDuration,
    taskDescription,
    setTaskdescription,
    importance,
    setImportance,
    frequency,
    setFrequency,
    messageBody,
    setMessageBody,
    familyMembers,
    setFamilyMembers,
    seniors,
    setSeniors,
    tasks,
    setTasks,
    caregivers,
    setCaregivers,
    globaltsk,
    setGlobaltsk,
    correct,
    setCorrect,
    famtofam,
    setFamtofam,
    logged,
    setLogged,
    filter,
    setFilter,
    filtercaregiver,
    setFilterCaregiver,
    filter2nd,
    setFilter2nd,
    filterAll,
    setFilterAll,
    filtermine,
    setFilterMine,
    filterunassigned,
    setFilterunassigned,
    clicks,
    setClicks,
    emails,
    setEmails,
    blogLogged,
    setBlogLogged,
    adminRedirect,
    setAdminRedirect
  };
  return <Provider value={api}>{children}</Provider>;
};

export { AppState, StateProvider };